export const InfoCircle = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="48" 
      height="48" 
      viewBox="0 0 48 48"
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
        <path opacity="0.4" d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"/>
        <path d="M24 27.5C24.82 27.5 25.5 26.82 25.5 26V16C25.5 15.18 24.82 14.5 24 14.5C23.18 14.5 22.5 15.18 22.5 16V26C22.5 26.82 23.18 27.5 24 27.5Z"/>
        <path d="M25.84 31.2398C25.74 30.9998 25.6 30.7798 25.42 30.5798C25.22 30.3998 25 30.2598 24.76 30.1598C24.28 29.9598 23.72 29.9598 23.24 30.1598C23 30.2598 22.78 30.3998 22.58 30.5798C22.4 30.7798 22.26 30.9998 22.16 31.2398C22.06 31.4798 22 31.7398 22 31.9998C22 32.2598 22.06 32.5198 22.16 32.7598C22.26 33.0198 22.4 33.2198 22.58 33.4198C22.78 33.5998 23 33.7398 23.24 33.8398C23.48 33.9398 23.74 33.9998 24 33.9998C24.26 33.9998 24.52 33.9398 24.76 33.8398C25 33.7398 25.22 33.5998 25.42 33.4198C25.6 33.2198 25.74 33.0198 25.84 32.7598C25.94 32.5198 26 32.2598 26 31.9998C26 31.7398 25.94 31.4798 25.84 31.2398Z"/>
    </svg>
  );
};